import React, { FC } from 'react'
import s from "./CameraPresetDropdown.module.scss"
import { CloseIcon } from '../../assets/svg/CloseIcon';
import { DeleteIcon } from '../../assets/svg/DeleteIcon';


export interface CameraPreset {
  id: string;
  label: string;
  config?: any;
}

export interface CameraPresetProps {
  presets: CameraPreset[];
  onSelect?: (preset: CameraPreset) => void;
  onClose?: () => void;
  onDelete?: (presetId: string) => void;
  onSave?: () => void;
}

export const CameraPresetDropdown: FC<CameraPresetProps> = ({ presets, onSelect, onClose, onDelete, onSave }) => {
  return (
      <div className={s.container}>
      <div className={s.cameraSetting}>
        <span>Camera settings</span>
        <div onClick={onClose} style={{ cursor: "pointer" }}>
          <CloseIcon />
        </div>
          </div>
          <div className={s.presetsList}>
      {presets.map(preset => (
        <div
          key={preset.id}
          className={s.preset}
          onClick={() => onSelect && onSelect(preset)}
        >
          {preset.label}
          <div
            style={{ cursor: 'pointer' }}
            onClick={e => {
              e.stopPropagation();
              onDelete && onDelete(preset.id);
            }}
          >
            <DeleteIcon fill='#6C757D' rectFill='#6C757D' />
          </div>
        </div>
      ))}
      </div>
      <div className={s.btnContainer}>
        <button className={s.saveBtn} onClick={onSave}>Save current camera</button>
        </div>
    </div>
  );
}
